import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  isExpanded: boolean;
  onClick: () => void;
  expandText?: string;
  collapseText?: string;
  className?: string;
};

export const ExpandButton: React.FC<Props> = ({
  isExpanded,
  onClick,
  expandText,
  collapseText,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Button onClick={onClick} className={className}>
      {isExpanded
        ? collapseText || t('buttons.collapse')
        : expandText || t('buttons.expand')}
    </Button>
  );
};
